import styles from '../../index.module.css'
import { StorePart } from '../../../../types/storePart'

export type ItemHeaderDetailsProps = {
	item: StorePart,
	hideLocation?: boolean,
}

export default function ItemHeaderDetails( { item, hideLocation }: ItemHeaderDetailsProps ) {
	return (
		<div className={styles.group}>
			<div className={styles.row}>
				Manufacturer: <span className={styles.value}>{item.part.provider.name}</span>
			</div>
			<div className={styles.row}>
				Description: <span className={styles.value}>{item.part.partClass.description}</span>
			</div>
			{ item.location && !hideLocation && (
				<div className={styles.row}>
					Location: <span className={styles.value}>{item.location}</span>
				</div>
			) }
		</div>
	)
}
